import React from 'react';
import styled from 'styled-components';
import { media } from 'helpers/MediaHelper';
import Event from './Event';

const ScrollablePanel = styled.div`
  height: 100%;
  padding: 2rem;
  padding-bottom: 40px;
  ${media.mobile`
    padding-bottom: 80px;
  `};
  overflow: scroll;
`;

const History = ({ events }) => {
  return (
    <React.Fragment>
      <ScrollablePanel>{events.map(event => <Event {...event} />)}</ScrollablePanel>
    </React.Fragment>
  );
};

export default History;
